import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1120px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          为什么选择包子漫画
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featuresData.map((f) => (
            <div
              key={f.title}
              className="p-6 rounded-xl bg-background-50 border border-background-200/70 flex flex-col items-center text-center"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-accent-100 rounded-xl mb-4">
                <i className={`${f.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}